var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"network-indicator px-1 inline-flex align-center"},[_c('div',{staticClass:"network-indicator__status mr-1",class:("bg-" + (_vm.$options.statusColor(_vm.props.networkId)))}),_vm._v("\n  "+_vm._s(_vm.$options.network(_vm.props.networkId))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }